export class UnauthenticatedError extends Error {
  readonly name = 'UnauthenticatedError';

  constructor(
    message: string = '',
    public readonly details?: unknown,
  ) {
    super(message);
  }
}

export class PermissionDeniedError extends Error {
  readonly name = 'PermissionDeniedError';

  constructor(
    message: string = '',
    public readonly details?: unknown,
  ) {
    super(message);
  }
}

export class NotFoundError extends Error {
  readonly name = 'NotFoundError';

  constructor(
    message: string,
    public readonly details?: unknown,
  ) {
    super(message);
  }
}
